import React from 'react';
import classes from './card.module.css';
import { getImageUrl } from '../../../utils/imageUrl';

const Food = (props) => {    
  const selectedItem = props?.selectedFood?.find((item) => item.item_id === props.id);
  // Function to handle selecting food items and updating count
  const handleFoodSelection = (foodId) => {
    props.setSelectedFood((prevSelectedFood) => {
      const itemIndex = prevSelectedFood.findIndex((item) => item.item_id === foodId);

      if (itemIndex >= 0) {
        // If the item is already selected, increment its count by 1
        const updatedFood = [...prevSelectedFood];
        updatedFood[itemIndex] = {
          ...updatedFood[itemIndex],
          quantity: updatedFood[itemIndex].quantity + 1,
        };
        return updatedFood;
      } else {
        // If the item is not selected, add it with a count of 1
        return [...prevSelectedFood, { item_id: foodId, quantity: 1 }];
      }
    });
  };

  // Function to decrement the count or remove the item
  const handleFoodDecrement = (foodId) => {
    props.setSelectedFood((prevSelectedFood) => {
      const itemIndex = prevSelectedFood.findIndex((item) => item.item_id === foodId);

      if (itemIndex >= 0) {
        const updatedFood = [...prevSelectedFood];
        if (updatedFood[itemIndex].quantity > 1) {
          // Decrement count by 1 if greater than 1
          updatedFood[itemIndex] = {
            ...updatedFood[itemIndex],
            quantity: updatedFood[itemIndex].quantity - 1,
          };
          return updatedFood;
        } else {
          // Remove the item if count is 1
          return updatedFood.filter((item) => item.item_id !== foodId);
        }
      }
      return prevSelectedFood;
    });
  };
  return (
    <div className={[classes.FoodCard, selectedItem && classes.Selected, classes[props.class]].join(" ")} onClick={props.onClick}>
      <img className={classes.FoodCardImage} src={getImageUrl(props.image)} alt={props.name} />
      <div className={classes.FoodData}>
        <div className={[classes.FoodCardDetails, props.description && classes.WithInfo].join(" ")}>
          <h2>{props.name}</h2>
          {props.people && <p>{props.people} Person</p>}
          {props.description && <div>{props.description}</div>}
          {props.liveStations &&
            <>
              <p>{props.shawerma}</p>
              <p>{props.burger}</p>
              <p>{props.fries}</p>
            </>}
        </div>
        {props?.hasCounter && <div className={classes.FoodCardCounter}>
          <button className={classes.CounterBtn} onClick={
            () => handleFoodDecrement(props.id)
          }>-</button>
          <div className={classes.CounterValue}>{selectedItem ? selectedItem.quantity : 0}</div>
          <button className={[classes.CounterBtn, classes.Increment].join(" ")} onClick={
            () => handleFoodSelection(props.id)
          }>+</button>
        </div>}
      </div>
    </div>
  );
};

export default Food;
